import { CONSENT_STATUS_ENUM, ConsentStatus, GA_DISABLED, GA_SHOW_CONSENT_BANNER } from '@/common/gaHelper';

const LS_GA_CONSENT_KEY = 'ga_consent';

export const getLSConsentStatus = (): ConsentStatus => {
  const savedStatus = window.localStorage.getItem(LS_GA_CONSENT_KEY) as ConsentStatus | null;

  return savedStatus || CONSENT_STATUS_ENUM.NOT_SET;
};

export const setLSConsentStatus = (status: string) => {
  window.localStorage.setItem(LS_GA_CONSENT_KEY, status);
};

const state = {
  consentStatus: getLSConsentStatus(),
};

const mutations = {
  setConsentStatus (state: any, status: ConsentStatus) {
    state.consentStatus = status;
    setLSConsentStatus(status);
  },
};

const getters = {
  showConsentBanner (state: any) {
    if (GA_DISABLED || !GA_SHOW_CONSENT_BANNER) {
      return false;
    }

    return state.consentStatus === CONSENT_STATUS_ENUM.NOT_SET;
  },
  showManageConsentButton (state: any) {
    if (GA_DISABLED || !GA_SHOW_CONSENT_BANNER) {
      return false;
    }

    return state.consentStatus !== CONSENT_STATUS_ENUM.NOT_SET;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
